import styled from 'styled-components';

export const Content = styled.div``;

export const Name = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #0a214280;
`;

export const Div = styled.div`
  &.active {
    color: var(--primary-green);
  }
  &.inactive {
    color: #ff646480;
  }
  &.captal {
    text-transform: capitalize;
  }

  &.full {
    width: 100%;
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef1f6;
  padding: 7px 10px;
  border-radius: 12px;
  font-size: 14px;
  color: #8a93ac;
  font-weight: 500;
`;

export const FilterButoons = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Button = styled.button`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
  color: var(--white);
  background: #8a93ac;
  min-width: 68px;
  border: none;
  height: 28px;
  border-radius: 8px;
  padding: 0 8px;

  &.active {
    background: var(--primary-dark-two);
  }
`;

export const Icon = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 40px;
  /* padding: 10px; */
`;

export const Image = styled.img`
  max-width: 100%;
  padding: 10px;
`;

export const Detail = styled.div``;

export const Item = styled.div`
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h4`
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0em;
  margin-bottom: 0;
  color: #8a93ac;
`;

export const MainTitle = styled.h4`
  width: 100%;
  font-size: 13px;
  font-weight: 700;
  line-height: 13px;
  letter-spacing: 0em;
  margin-bottom: 10px;
  color: #030e30;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Text = styled.p`
  font-size: 13px;
  font-weight: 400;
  line-height: 13px;
  letter-spacing: 0em;
  display: flex;
  align-items: center;
  justify-content: space-between;

  span {
    color: var(--white);
    font-size: 12px;
    font-weight: 400;
    padding: 2px 10px 3px 10px;
    background-color: #d18363;
    border-radius: 30px;
  }
`;

export const GridMain = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Ensures 3 boxes per row */
  gap: 1rem;
  align-items: start;
`;

export const Grid = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const UserCard = styled.div`
  padding: 8px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  width: 100%;
`;

export const Span = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 400;
  color: #979797;
  text-align: right;
`;

export const GridButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 3rem;
`;

export const PeopleContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(1, 1fr); /* Ensures 3 boxes per row */
  gap: 1rem;
  align-items: start;
  margin-top: 15px;
`;

export const Message = styled.p`
  text-align: center;
`;
